// extracted by mini-css-extract-plugin
export var activityContainer = "_f1-0";
export var typingIndicatorContainer = "_f1-1";
export var typingIndicatorDot = "_f1-2";
export var wave = "_f1-3";